var render = function render(){var _vm=this,_c=_vm._self._c;return _c('objects',{attrs:{"title":"Список оценочных групп/подгрупп","objects":_vm.groups,"attrs_all":_vm.attrs,"set_page_local":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }